import { render, staticRenderFns } from "./teoriakoulutus-tallennettu.vue?vue&type=template&id=64938ce2&scoped=true&"
import script from "./teoriakoulutus-tallennettu.vue?vue&type=script&lang=ts&"
export * from "./teoriakoulutus-tallennettu.vue?vue&type=script&lang=ts&"
import style0 from "./teoriakoulutus-tallennettu.vue?vue&type=style&index=0&id=64938ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64938ce2",
  null
  
)

export default component.exports